import { render } from "./AccountComponent.vue?vue&type=template&id=19064a5e"
import script from "./AccountComponent.vue?vue&type=script&lang=js"
export * from "./AccountComponent.vue?vue&type=script&lang=js"

import "./AccountComponent.vue?vue&type=style&index=0&id=19064a5e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__